import axios from "axios";

export const getUtentiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/`, {
        params: params
    });
}

export const getUtenteByIdApi = (idUtente, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}`, {
        params: params
    });
}

export const deleteUtenteApi = (idUtente, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}`, {
        params: params
    });
}

export const aggiornaUtenteApi = (idUtente, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}`, payload, {
        params: params
    });
}

export const aggiungiUtenteApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/socio/`, payload, {
        params: params
    });
}

export const getSociApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/socio/`, {
        params: params
    });
}

export const getCsvSociApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/socio/csv/`, {
        params: params
    });
}

export const deleteSocioApi = (idSocio, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/socio/${idSocio}`, {
        params: params
    });
}

export const getSocioByIdApi = (idSocio, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/socio/${idSocio}`, {
        params: params
    });
}

export const getCommissariApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/commissario/`, {
        params: params
    });
}

export const getTipiSociApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/tipi-socio/`, {
        params: params
    });
}

export const getTipoSocioByIdApi = (idTipoSocio, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/tipi-socio/${idTipoSocio}`, {
        params: params
    });
}

export const aggiornaTipoSocioApi = (idTipoSocio, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/tipi-socio/${idTipoSocio}`, payload, {
        params: params
    });
}

export const aggiungiTipoSocioApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/tipi-socio/`, payload, {
        params: params
    });
}

export const getAgenzieApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/agenzie/`, {
        params: params
    });
}

export const getAgenziaByIdApi = (idAgenzia, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/agenzie/${idAgenzia}`, {
        params: params
    });
}

export const deleteAgenziaApi = (idAgenzia, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/agenzie/${idAgenzia}`, {
        params: params
    });
}

export const aggiornaAgenziaApi = (idAgenzia, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/agenzie/${idAgenzia}`, payload, {
        params: params
    });
}

export const aggiungiAgenziaApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/agenzie/`, payload, {
        params: params
    });
}

export const getClubsApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/club/`, {
        params: params
    });
}

export const getClubByIdApi = (idClub, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/club/${idClub}`, {
        params: params
    });
}

export const aggiornaClubApi = (idClub, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/club/${idClub}`, payload, {
        params: params
    });
}

export const aggiungiClubApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/club/`, payload, {
        params: params
    });
}

export const deleteClubApi = (idClub, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/club/${idClub}`, {
        params: params
    });
}

export const getTipiRegistroApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/tipi-registro/`, {
        params: params
    });
}

export const getTipiDocumentoUtenteApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/tipo-documento/`, {
        params: params
    });
}

export const getTitoliUtenteApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/titolo/`, {
        params: params
    });
}

export const getTitoloUtenteByIdApi = (idTitolo, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/titolo/${idTitolo}`, {
        params: params
    });
}

export const aggiornaTitoloUtenteApi = (idTitolo, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/titolo/${idTitolo}`, payload, {
        params: params
    });
}

export const aggiungiTitoloUtenteApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/titolo/`, payload, {
        params: params
    });
}

export const deleteTitoloUtenteApi = (idTitolo, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/titolo/${idTitolo}`, {
        params: params
    });
}

export const getNazioniApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/indirizzo/nazione/`, {
        params: params
    });
}

export const getRegioniApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/indirizzo/regione/`, {
        params: params
    });
}

export const getProvinceApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/indirizzo/provincia/`, {
        params: params
    });
}

export const getComuniApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/indirizzo/comune/`, {
        params: params
    });
}

export const getCertificatiUtenteApi = (idUtente, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/certificato/`, {
        params: params
    });
}

export const getStampaUtenteApi = (idUtente, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/stampa/`, {
        params: params
    });
}

export const getEtichetteUtentiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/stampa/etichetta/`, {
        params: params
    });
}

export const getRichiedentiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/richiedente/`, {
        params: params
    });
}

export const aggiornaStatoUtenteApi = (idUtente, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/stato/`, payload, {
        params: params
    });
}

export const getSociSimiliApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/richiedente/simile/`, {
        params: params
    });
}

export const getRinnoviApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/rinnovo/`, {
        params: params
    });
}

export const getStampeUtentiApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/stampa/`, {
        params: params
    });
}

export const getDocumentoUtenteApi = (idUtente, idDocumento, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/documento/${idDocumento}`, {
        params: params
    });
}

export const getMotiviRegistrazioneApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/motivi-registrazione/`, {
        params: params
    });
}

export const aggiungiPasswordApi = (idUtente, jwt, payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/password/`, payload, {
        params: params,
        headers: {
            jwt: jwt
        }
    });
}

export const resetPasswordApi = (idUtente, jwt, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/password/`, payload, {
        params: params,
        headers: {
            jwt: jwt
        }
    });
}

export const loginApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/login`, payload, {
        params: params,
    });
}

export const inviaEmailRecuperaPasswordApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/password/mail/`, payload, {
        params: params,
    });
}

export const getInfoPagamentoUtenteApi = (idUtente, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/info-pagamento/`, {
        params: params,
    });
}

export const getDocumentiSocioApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/documenti-socio/`, {
        params: params,
    });
}

export const getDocumentoSocioByIdApi = (idDocumento, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/documenti-socio/${idDocumento}`, {
        params: params,
    });
}

export const confermaPagamentoApi = (idUtente, idTransazione, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/pagamento/conferma/${idTransazione}`, payload, {
        params: params,
    });
}

export const aggiungiQuotaTempSocioApi = (idUtente, payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/quota-temp/`, payload, {
        params: params,
    });
}

export const getRuoliApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/ruolo/`, {
        params: params,
    });
}